import { render, staticRenderFns } from "./modificationVip.vue?vue&type=template&id=c5dae7d2&scoped=true&"
import script from "./modificationVip.vue?vue&type=script&lang=js&"
export * from "./modificationVip.vue?vue&type=script&lang=js&"
import style0 from "./modificationVip.vue?vue&type=style&index=0&id=c5dae7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dae7d2",
  null
  
)

export default component.exports